import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Bots from '../views/Bots.vue'
import Editor from '../views/Editor.vue'
import Payment from '../views/Payment.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Leaderboard from '../views/Leaderboard.vue'
import UserGuide from '../views/UserGuide.vue'
import Tutorials from '../views/Tutorials.vue'
import Templates from '../views/Templates.vue'
import Covid19Tracker from '../views/Covid19Tracker.vue'
import DogsForever from '../views/DogsForever.vue'
import ShoppingBot from '../views/ShoppingBot.vue'
import AllBots from '../views/AllBots.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import RefundPolicy from '../views/RefundPolicy.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import AboutUs from '../views/AboutUs.vue'
import ContactUs from '../views/ContactUs.vue'
import Pricing from '../views/Pricing.vue'


import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next({ name: 'login', params: { to: to }})
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/bots',
    name: 'bots',
    component: Bots,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/editor/:token',
    name: 'editor',
    component: Editor,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/leaderboard/:token',
    name: 'leaderboard',
    component: Leaderboard,
    props: true,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/user-guide',
    name: 'UserGuide',
    component: UserGuide
  },
  {
    path: '/tutorials',
    name: 'Tutorials',
    component: Tutorials
  },
  {
    path: '/all_bots',
    name: 'AllBots',
    component: AllBots
  },
  {
    path: '/tutorials/covid19Tracker',
    name: 'Covid19Tracker',
    component: Covid19Tracker
  },
  {
    path: '/tutorials/dogsforever',
    name: 'DogsForever',
    component: DogsForever
  },
  {
    path: '/tutorials/shoppingBot',
    name: 'ShoppingBot',
    component: ShoppingBot
  },
  {
    path: '/templates',
    name: 'Templates',
    component: Templates,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  },
  {
    path: '/refund-policy',
    name: 'RefundPolicy',
    component: RefundPolicy
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
